import { SidebarItem, SidebarSection } from "../../ui";

import type { ShellNavRoute, ShellRouteState } from "../../lib/shellNavigation";

export interface SidebarNavProps {
  area: ShellRouteState["area"];
  onNavigate: (to: ShellNavRoute) => void;
}

// The grouped rail (founder-ratified shell IA, 2026-07-07; Personas added by
// founder ruling 2026-07-16; Simulations leads the rail by founder ruling
// 2026-07-26; grouped into Library / Quality / Monitor by founder ruling
// 2026-07-31, which also folded Templates into Simulations as a tab and
// promoted Scenarios to the rail).
// Order is exact: ungrouped Simulations + Transcripts, then Library
// (Markers · Personas · Scenarios), Quality (Review),
// Monitor (Dashboard · Alerts), then ungrouped Settings LAST (docs/09 §4).
// Section headings render as small-caps label rows; the persisted collapsed
// (icon-only) rail hides the text and renders a hairline divider between
// sections instead (styles.css, `.marker-app-shell--collapsed`).
// Every item is a top-level, agent-scoped product surface. Agent
// identity/settings are reached from the agent selector, not a rail item.
export function SidebarNav({ area, onNavigate }: SidebarNavProps) {
  return (
    <>
      <SidebarSection>
        <SidebarItem
          icon="play"
          isActive={area === "simulations"}
          label="Simulations"
          onClick={() => {
            onNavigate("/simulations");
          }}
        />
        <SidebarItem
          icon="fileText"
          isActive={area === "transcripts"}
          label="Transcripts"
          onClick={() => {
            onNavigate("/transcripts");
          }}
        />
      </SidebarSection>
      <SidebarSection title="Library">
        <SidebarItem
          icon="clipboardCheck"
          isActive={area === "markers"}
          label="Markers"
          onClick={() => {
            onNavigate("/markers");
          }}
        />
        <SidebarItem
          icon="users"
          isActive={area === "personas"}
          label="Personas"
          onClick={() => {
            onNavigate("/personas");
          }}
        />
        {/* `route`, not `book`: the top bar's Documentation link owns `book`,
            and both go icon-only in the collapsed rail. */}
        <SidebarItem
          icon="route"
          isActive={area === "scenarios"}
          label="Scenarios"
          onClick={() => {
            onNavigate("/scenarios");
          }}
        />
      </SidebarSection>
      <SidebarSection title="Quality">
        <SidebarItem
          icon="user"
          isActive={area === "review"}
          label="Review"
          onClick={() => {
            onNavigate("/review");
          }}
        />
      </SidebarSection>
      <SidebarSection title="Monitor">
        <SidebarItem
          icon="dashboard"
          isActive={area === "dashboard"}
          label="Dashboard"
          onClick={() => {
            onNavigate("/dashboard");
          }}
        />
        <SidebarItem
          icon="alerts"
          isActive={area === "alerts"}
          label="Alerts"
          onClick={() => {
            onNavigate("/alerts");
          }}
        />
      </SidebarSection>
      <SidebarSection>
        <SidebarItem
          icon="settings"
          isActive={area === "settings"}
          label="Settings"
          onClick={() => {
            onNavigate("/settings");
          }}
        />
      </SidebarSection>
    </>
  );
}
